import { render, staticRenderFns } from "./DeliveryPage.vue?vue&type=template&id=a237ab2a&scoped=true&"
import script from "./DeliveryPage.vue?vue&type=script&lang=js&"
export * from "./DeliveryPage.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryPage.vue?vue&type=style&index=0&id=a237ab2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a237ab2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
